import * as types from './types';
import { apiGetArcades } from './api';
import { ArcadeListItem } from './interfaces';

export const setArcadesList = (list: Array<ArcadeListItem>) => ({
    type: types.ARCADE_LIST__SET_ARCADE_SEARCH_RESULTS,
    list
});

export const getArcades = () => async (dispatch) => {
    const results = await apiGetArcades();
    return await dispatch(setArcadesList(results.arcades));
};
